var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWoman7(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 434 434",
    style: {
      enableBackground: "new 0 0 434 434"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M305.505,283h-177.01V148c0-48.12,38.4-87.26,86.22-88.47c0.76-0.02,1.52-0.03,2.28-0.03h0.01 c48.87,0,88.5,39.62,88.5,88.5V283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M305.505,289h-177.01c-3.313,0-6-2.687-6-6V148c0-24.82,9.548-48.266,26.885-66.019 c17.305-17.72,40.454-27.824,65.184-28.45c0.806-0.021,1.618-0.032,2.432-0.032c52.117,0,94.51,42.393,94.51,94.5v135 C311.505,286.313,308.818,289,305.505,289z M134.495,277h165.01V148c0-45.491-37.01-82.5-82.5-82.5 c-0.718,0-1.425,0.009-2.132,0.028c-21.592,0.546-41.8,9.367-56.908,24.838c-15.135,15.498-23.47,35.966-23.47,57.634V277z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E6E6"
    },
    d: "M266.355,256.97c0.19,0.05,0.39,0.09,0.58,0.14c10.46,2.53,20.19,6.93,28.83,12.81 c23.39,15.92,38.75,42.77,38.75,73.19V428h-47.04h-140.96h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 c8.64-5.88,18.37-10.28,28.83-12.81c0.19-0.05,0.39-0.09,0.58-0.14"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M146.515,304v124h-47.03v-84.89c0-30.42,15.35-57.27,38.74-73.19 C143.525,280.12,146.515,291.71,146.515,304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M334.515,343.11V428h-47.04V304c0-12.29,2.99-23.88,8.29-34.08 C319.155,285.84,334.515,312.69,334.515,343.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M342.5,428h-12v-78.69c0-25.83-11.669-50.163-32.857-68.515 C276.213,262.226,247.663,252,217.25,252C154.804,252,104,295.653,104,349.31V428H92v-78.69C92,289.036,148.187,240,217.25,240 c33.299,0,64.64,11.267,88.25,31.725c23.859,20.666,37,48.22,37,77.585V428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M293.475,428h-12V304c0-12.816,3.101-25.558,8.966-36.846l10.648,5.533 c-5.053,9.724-7.614,20.259-7.614,31.313V428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M314.515,414c-3.313,0-6-2.687-6-6v-73c0-3.313,2.687-6,6-6s6,2.687,6,6v73 C320.515,411.313,317.828,414,314.515,414z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M143.165,281.92c-15.21,15.89-24.56,37.45-24.56,61.19 V426h-19.12v-82.89c0-30.42,15.35-57.27,38.74-73.19C140.205,273.74,141.865,277.75,143.165,281.92z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M152.515,428h-12V304c0-11.054-2.562-21.59-7.614-31.313l10.648-5.533 c5.865,11.289,8.966,24.03,8.966,36.846V428z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M251.479,404h-68.96c-23.159,0-42-18.841-42-42h12c0,16.542,13.458,30,30,30h68.96 c16.542,0,30-13.458,30-30h12C293.479,385.159,274.639,404,251.479,404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M251.479,386c-3.313,0-6-2.687-6-6s2.687-6,6-6c6.617,0,12-5.383,12-12c0-3.313,2.687-6,6-6 s6,2.687,6,6C275.479,375.234,264.713,386,251.479,386z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M257.09,248v65.36c0,14.71-11.93,26.64-26.64,26.64h-30.72c-14.71,0-26.64-11.93-26.64-26.64V248 c12.5,6.75,26.8,10.58,41.99,10.58C230.29,258.58,244.59,254.75,257.09,248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M230.45,346h-30.721c-17.998,0-32.64-14.642-32.64-32.64V248h12v65.36 c0,11.381,9.259,20.64,20.64,20.64h30.721c11.381,0,20.64-9.259,20.64-20.64V248h12v65.36C263.09,331.358,248.448,346,230.45,346 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M215.09,346c-3.313,0-6-2.687-6-6v-15c0-3.313,2.687-6,6-6s6,2.687,6,6v15 C221.09,343.313,218.403,346,215.09,346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M260.91,246c-1.18,2.25-2.45,16.06-3.82,18.18 c-6.42,10.03-14.81,18.67-24.62,25.39c-0.19,0.14-0.39,0.27-0.58,0.4c-14.1,9.49-31.08,15.03-49.36,15.03 c-5.24,0-6.11-4.72-9.44-7.26V248c11.87,5.92,29.24,12,43.41,12C234.36,260,247.01,255.09,260.91,246z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M348.5,434H85.729c-3.313,0-6-2.687-6-6s2.687-6,6-6H348.5c3.313,0,6,2.687,6,6 S351.813,434,348.5,434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M380.5,434h-11c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6S383.813,434,380.5,434z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M64.5,434h-11c-3.313,0-6-2.687-6-6s2.687-6,6-6h11c3.313,0,6,2.687,6,6S67.813,434,64.5,434z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD3AE"
    },
    cx: 136.432,
    cy: 146,
    r: 27.89
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD3AE"
    },
    cx: 297.567,
    cy: 146,
    r: 27.89
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M136.433,179.89c-18.688,0-33.891-15.203-33.891-33.89s15.203-33.89,33.891-33.89 c18.687,0,33.89,15.203,33.89,33.89S155.119,179.89,136.433,179.89z M136.433,124.11c-12.07,0-21.891,9.82-21.891,21.89 s9.82,21.89,21.891,21.89s21.89-9.82,21.89-21.89S148.503,124.11,136.433,124.11z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M297.567,179.89c-18.687,0-33.89-15.203-33.89-33.89s15.203-33.89,33.89-33.89 s33.89,15.203,33.89,33.89S316.254,179.89,297.567,179.89z M297.567,124.11c-12.07,0-21.89,9.82-21.89,21.89 s9.819,21.89,21.89,21.89s21.89-9.82,21.89-21.89S309.638,124.11,297.567,124.11z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD3AE"
    },
    d: "M266.36,241.97C252.26,251.46,235.28,257,217,257s-35.26-5.54-49.36-15.03 c-0.19-0.13-0.39-0.26-0.58-0.4c-23.28-15.94-38.56-42.72-38.56-73.07V146V94.5C128.5,45.623,168.123,6,217,6l0,0 c48.877,0,88.5,39.623,88.5,88.5V146v22.5c0,30.35-15.28,57.13-38.56,73.07C266.75,241.71,266.55,241.84,266.36,241.97z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7774B"
    },
    d: "M217,216.01c-4.869,0-9.738-0.513-14.572-1.538c-3.242-0.688-5.313-3.873-4.625-7.114 c0.687-3.241,3.874-5.31,7.113-4.625c8.02,1.7,16.148,1.7,24.168,0c3.239-0.687,6.427,1.384,7.113,4.625 c0.688,3.242-1.383,6.427-4.625,7.114C226.738,215.497,221.869,216.01,217,216.01z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.44
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M217.505,229h-1.01c-2.209,0-4-1.791-4-4s1.791-4,4-4h1.01c2.209,0,4,1.791,4,4 S219.714,229,217.505,229z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M245.527,140.414c-2.725,0-5.19-1.868-5.838-4.635c-0.754-3.227,1.25-6.454,4.477-7.209 c9.703-2.269,19.963-2.27,29.668,0c3.227,0.754,5.23,3.982,4.477,7.208c-0.755,3.226-3.977,5.233-7.209,4.476 c-7.919-1.852-16.288-1.851-24.203,0C246.439,140.362,245.979,140.414,245.527,140.414z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M198.64,241.97c10.02,6.74,21.5,11.49,33.86,13.68 c-5.03,0.89-10.21,1.35-15.5,1.35c-18.28,0-35.26-5.54-49.36-15.03c-0.19-0.13-0.39-0.26-0.58-0.4 c-23.28-15.94-38.56-42.72-38.56-73.07V146c0-139,54.89-137.301,54.89-134.411l-10.384,15.807 c-15.364,23.387-15.306,53.174-0.958,76.231c2.423,3.895,10.151,17.294,10.019,20.366c-0.483,11.29-9.201,21.36-21.338,21.975 c-0.407,0.021-0.817,0.031-1.229,0.031v22.5c0,30.35,15.28,57.13,38.56,73.07C198.25,241.71,198.45,241.84,198.64,241.97z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 182.66,
    cy: 157.116,
    r: 8.009
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M167.33,164.208c-1.533,0-3.065-0.583-4.236-1.751c-2.347-2.34-2.353-6.139-0.013-8.485 c6.153-6.172,15.55-7.746,23.376-3.919c2.978,1.455,4.211,5.048,2.756,8.025c-1.456,2.976-5.047,4.212-8.025,2.756 c-3.218-1.573-7.079-0.925-9.608,1.611C170.407,163.62,168.868,164.208,167.33,164.208z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#333333"
    },
    cx: 251.34,
    cy: 157.116,
    r: 8.009
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M266.669,164.208c-1.539,0-3.077-0.588-4.249-1.764c-2.529-2.537-6.39-3.183-9.607-1.611 c-2.978,1.456-6.57,0.222-8.025-2.755c-1.455-2.977-0.222-6.57,2.756-8.025c7.827-3.827,17.223-2.252,23.375,3.919 c2.34,2.347,2.334,6.146-0.013,8.485C269.734,163.624,268.201,164.208,266.669,164.208z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M210.057,189c-3.313,0-6-2.687-6-6v-32.927c0-2.692-1.515-5.195-3.858-6.375 c-7.192-3.621-19.527-7.154-37.439-3.412c-3.245,0.677-6.422-1.403-7.1-4.647c-0.678-3.244,1.403-6.422,4.646-7.1 c21.306-4.448,36.389-0.04,45.289,4.441c6.453,3.25,10.462,9.799,10.462,17.093V183C216.057,186.313,213.37,189,210.057,189z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M130.795,140.7l-0.8,0.3h-1.5V94.5c0-48.12,38.4-87.26,86.22-88.47l2.28,0.97v71.56 C194.705,106.3,165.085,127.97,130.795,140.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.44,
      fill: "#333333",
      enableBackground: "new"
    },
    d: "M216.995,7v9.32c-27.96,14.87-46.99,44.3-46.99,78.18v26.51 c-12.19,7.91-25.32,14.54-39.21,19.69l-0.8,0.3h-1.5V94.5c0-48.12,38.4-87.26,86.22-88.47L216.995,7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M303.205,140.7c-34.3-12.73-63.92-34.4-86.21-62.14V7l-2.28-0.97c0.76-0.02,1.52-0.03,2.28-0.03 h0.01c48.87,0,88.5,39.62,88.5,88.5V141h-1.51L303.205,140.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M287.505,109c-3.313,0-6-2.687-6-6v-8.5c0-21.382-10.606-41.347-28.373-53.406 c-2.741-1.861-3.455-5.592-1.595-8.334c1.861-2.741,5.592-3.457,8.335-1.595c21.06,14.294,33.633,37.971,33.633,63.334v8.5 C293.505,106.313,290.818,109,287.505,109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M240.424,34.001c-0.663,0-1.337-0.11-1.998-0.344c-1.627-0.575-3.297-1.089-4.963-1.529 c-3.203-0.846-5.115-4.129-4.269-7.333c0.846-3.204,4.127-5.114,7.333-4.27c1.979,0.522,3.962,1.134,5.895,1.816 c3.124,1.104,4.763,4.531,3.659,7.655C245.212,32.461,242.896,34.001,240.424,34.001z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M216.995,263c-18.873,0-37.097-5.551-52.7-16.052c-0.232-0.151-0.486-0.323-0.731-0.503 c-25.72-17.663-41.068-46.79-41.068-77.944v-74c0-24.82,9.548-48.266,26.885-66.019c17.305-17.72,40.454-27.824,65.184-28.45 C215.369,0.01,216.182,0,216.995,0c52.117,0,94.51,42.393,94.51,94.5v74c0,31.176-15.366,60.32-41.105,77.977 c-0.139,0.099-0.281,0.196-0.422,0.291l-0.104,0.071c-0.058,0.041-0.1,0.07-0.158,0.109C254.111,257.449,235.881,263,216.995,263z  M217.005,12c-0.718,0-1.425,0.009-2.132,0.028c-21.592,0.546-41.8,9.367-56.908,24.838c-15.135,15.498-23.47,35.966-23.47,57.634 v74c0,27.236,13.442,52.702,35.959,68.119c0.098,0.067,0.194,0.137,0.288,0.21l0.159,0.102c0.021,0.015,0.071,0.047,0.093,0.062 C184.61,246.156,200.518,251,216.995,251c16.464,0,32.354-4.829,45.956-13.964c0.109-0.077,0.224-0.155,0.34-0.233l0.115-0.078 c0.055-0.041,0.093-0.067,0.149-0.106c22.51-15.414,35.949-40.878,35.949-68.119v-74C299.505,49.009,262.495,12,217.005,12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#333333"
    },
    d: "M132.102,146.618l-4.213-11.236l0.8-0.3c32.816-12.183,61.729-33.025,83.63-60.28 c1.139-1.417,2.858-2.242,4.677-2.242s3.538,0.824,4.677,2.242c21.902,27.257,50.817,48.099,83.621,60.273l0.831,0.315 l-4.258,11.22l-0.79-0.3c-32.508-12.065-61.449-32.18-84.081-58.378c-22.63,26.197-51.57,46.313-84.112,58.394L132.102,146.618z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 210.995,
    y: 7,
    style: {
      fill: "#333333"
    },
    width: 12,
    height: 71.56
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M287.505,192c-3.313,0-6-2.687-6-6v-29c0-3.313,2.687-6,6-6s6,2.687,6,6v29 C293.505,189.313,290.818,192,287.505,192z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoman7);
export default __webpack_public_path__ + "static/media/woman7.a55960b5228446ee64225c70f7393741.svg";
export { ForwardRef as ReactComponent };